var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRelogio01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2_",
    d: "M18,35.5L18,35.5C8.4,35.5,0.5,27.6,0.5,18S8.4,0.5,18,0.5S35.5,8.4,35.5,18c0,7.1-4.3,13.4-10.8,16.1 C22.6,35,20.3,35.5,18,35.5z M17,8.3c-0.6,0-1.1,0.5-1.1,1.1v10.4c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.3,0.2,0.4l4.4,4.5 c0.2,0.2,0.5,0.3,0.8,0.3h0c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.3-0.1,0.4-0.2l1.6-1.6c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8 l-3.2-3.2c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.1-0.1-0.3-0.1-0.4V9.4c0-0.6-0.5-1.1-1.1-1.1H17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRelogio01);
export default __webpack_public_path__ + "static/media/ico-relogio-01.ffef590a01c24cf2417326ba92363f65.svg";
export { ForwardRef as ReactComponent };